import { createAction, props } from '@ngrx/store';
import {
  AssignmentInstance,
  FormConfig,
  SubmitAssignment,
} from '../types/config.type';
import { ComponentType } from '@angular/cdk/overlay';

const startNewAssignment = createAction(
  '[Assignment] Start New Assignment',
  props<AssignmentInstance>(),
);

const switchForm = createAction(
  '[Assignment] Switch Form',
  props<FormConfig>(),
);
const searchEntity = createAction(
  '[Assignment] Search Entity',
  props<{ query: string; entity: string }>(),
);

const foundEntity = createAction(
  '[Assignment] Entity result',
  props<{ entity: string }>(),
);

const assignEntity = createAction(
  '[Assignment] Assign Entity',
  props<{ targetType: string; targetId: string; entity: string; body: any }>(),
);

const searchEntitySuccess = createAction(
  '[Assignment] Search Entity Success',
  props<{
    result: {
      id: string;
    };
  }>(),
);

const submitAssignment = createAction(
  '[Assignment] Submit Assignment',
  props<{
    props: SubmitAssignment;
  }>(),
);

const submitAssignmentSuccess = createAction(
  '[Assignment] Submit Assignment Success',
);

const submitAssignmentFailure = createAction(
  '[Assignment] Submit Assignment Failure',
  props<{ error: string }>(),
);

const searchEntityFailure = createAction('[Assignment] Search Entity Failure');

export const ASSIGNMENT_ACTIONS = {
  assignEntity,
  foundEntity,
  searchEntity,
  searchEntityFailure,
  searchEntitySuccess,
  startNewAssignment,
  submitAssignment,
  submitAssignmentFailure,
  submitAssignmentSuccess,
  switchForm,
};

/**
 * @DIALOG ACTIONS
 * */
const openDialog = createAction(
  '[Assignment] Open Dialog',
  props<{
    component: () => ComponentType<unknown>;
    data: unknown;
  }>(),
);

const onCloseDialog$ = createAction(
  '[Assignment] Close Dialog',
  props<{
    data: unknown;
  }>(),
);

export const ASSIGNMENT_DIALOG_ACTIONS = {
  openDialog,
  onCloseDialog$,
};
